import React, { useEffect, useRef } from 'react';

import { IconLightspeedLight24 } from '@lightspeed/unified-components-default-consumer-theme/react';
import { T } from '@transifex/react';

interface StickyFooterProps {
  children: React.ReactNode;
}

export function StickyFooter({ children }: StickyFooterProps) {
  const footerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const footer = footerRef.current;

    if (!footer) return undefined;

    document.body.style.paddingBottom = `${footer.clientHeight}px`;

    return () => {
      document.body.style.paddingBottom = '0px';
    };
  }, []);

  return (
    <div
      ref={footerRef}
      className="bg-app-primary fixed left-0 right-0 bottom-0 z-[2] border-t-sm border-neutral-soft px-4 py-4 flex flex-col gap-4"
    >
      {children}
      <div className="flex-shrink-0 sticky bottom-0 flex justify-center items-center gap-2 border-t-sm typography-body-sm border-neutral-soft mx-2 pt-3">
        <IconLightspeedLight24 />
        <a
          href="https://www.lightspeedhq.com"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Powered by Lightspeed"
          className="group"
        >
          <T
            _str="Powered by {brand}"
            _context="Footer branding text showing powered by Lightspeed"
            _tags="widget"
            _key="Widget.Footer.poweredByLightspeed.label"
            brand={<span className="group-hover:underline">Lightspeed</span>}
          />
        </a>
      </div>
    </div>
  );
}
